import React, { useContext } from "react";
import ReactGA from "react-ga4";
import { Icon } from "antd";
import styles from "./styles/SharingOptions.scss";
import { Context as ShareContext } from "../../ShareContex";
import useHrPageName from "../../utils/useHrPageName";

function SharingOptions(props: any) {
  const { category } = props;
  const { toggleShare } = useContext(ShareContext);
  const hrPageName = useHrPageName(category);

  return (
    <span
      role="button"
      tabIndex={0}
      onClick={() => {
        ReactGA.event({
          category: "Detalji oglasa",
          action: "Click",
          label: `Podijeli oglas (gornji) - ${hrPageName}`
        });
        toggleShare();
      }}
      className={styles.sharingButton}
      title={"Podijeli"}
    >
      <Icon type="share-alt" className={styles.icon} />
      {"Podijeli"}
    </span>
  );
}

export default SharingOptions;



// WEBPACK FOOTER //
// ./src/components/SharingOptions/index.tsx